
$(document).ready(function () {

	// Top nav
	(function () {
		$('.menu-item-has-children > a').click(function (e) {
			e.preventDefault();
			if ($(this).parent().hasClass('active')) {
				$(this).next().slideUp();
				$(this).parent().removeClass('active');
			}
			else {
				$('.menu-item-has-children').removeClass('active');
				$('.menu-item-has-children ul').slideUp();
				$(this).next().slideDown();
				$(this).parent().addClass('active');
			}
		});

	})();

	// Nav toggle
	(function () {

		$('.nav-toggle').click(function () {
			$('.site-nav').slideToggle();
			$(this).toggleClass('open');
		});

	})();

	// Slider
	(function () {

		var slider = $('.slider');
		if (slider.length) {
			$('.slider').slick({
				// setting-name: setting-value
			});
		}

		$('.gallery-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			fade: false,
			asNavFor: '.gallery-slider-thumbs'
		});

		var slideNum = $('.gallery-slider-thumbs').children().length;

		$('.gallery-slider-thumbs').slick({
			slidesToShow: slideNum,
			slidesToScroll: 1,
			asNavFor: '.gallery-slider',
			dots: true,
			focusOnSelect: true,
			vertical: true
		});

		// Remove active class from all thumbnail slides
		$('.gallery-slider-thumbs .slick-slide').removeClass('slick-active');

		// Set active class to first thumbnail slides
		$('.gallery-slider-thumbs .slick-slide').eq(0).addClass('slick-active');

		// On before slide change match active thumbnail to current slide
		$('.gallery-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			var mySlideNumber = nextSlide;
			$('.gallery-slider-thumbs .slick-slide').removeClass('slick-active');
			$('.gallery-slider-thumbs .slick-slide').eq(mySlideNumber).addClass('slick-active');
		});

	})();

	// Map
	(function () {

		if ($('#map').length) {
			initMap();
		}

	})();

});

function initMap() {
	var uluru = {lat: 51.896402, lng: -1.843028};
	var map = new google.maps.Map(document.getElementById('map'), {
		zoom: 12,
		center: uluru
	});
	var marker = new google.maps.Marker({
		position: uluru,
		map: map,
		icon: '../wp-content/themes/aylworth/assets/img/pin.png'
	});
}
